export const toPascalCase = (str) => {
  if (!str) {
    return "";
  }
  return str
    .split(" ") // Split the string into an array of words
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize the first letter of each word and lowercase the rest
    )
    .join(" "); // Join the words back into a string with spaces
};
export const allowOnlyAlphabetsAndSpaces = (str) => /^[A-Za-z.-]+(?: [A-Za-z.-]+)*( ?)$/.test(str);

export const allowOnlyNumbers = (str) => /^[0-9]*$/.test(str);

export const allowPincodeOrOtp = (str) => /^[0-9]{0,6}$/.test(str);

export const isValidMobileNumber = (value) => /^(?!([6-9])\1{9})[6-9]\d{9}$/.test(value);

export const isValidVehicleNumber = (value) =>
  // /^[A-Za-z]{1,2}[0-9]{1,2}[A-Za-z]{0,2}[0-9]{4}$/.test(value);
/^[A-Z]{2}(0[1-9]|[1-9][0-9])[A-Z]{1,2}(000[1-9]|00[1-9][0-9]|0[1-9][0-9]{2}|[1-9][0-9]{3})$/.test(value);

export const isValidBharatSeriesNumber = (value) =>
  // /^[0-9]{2}BH[0-9]{4}[A-HJ-NP-Z]{1,2}$/.test(value);
/^(0[1-9]|[1-9][0-9])BH(000[1-9]|00[1-9][0-9]|0[1-9][0-9]{2}|[1-9][0-9]{3})[A-Z]{0,2}$/.test(value);

export const formattedNumber = (number) => {
  if (!!number) {
    if (typeof number === "number") {
      return number.toFixed(2);
    } else if (typeof number === "string") {
      return number;
    }
  }
  return "";
};

export const DLregex =
  /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/;
export const licenseRegex = /^[A-Z]{2}[- ]?\d{2} ?\d+$/;
export const alphanumericWhitespaceRegex = /^[a-zA-Z0-9\s]*$/;
export const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
export const consecutiveNewLineRegex = /\n\n/;
export const excessiveRepetitionRegex = /(\d)\1{4,}/;
export const alphanumericRegex = /^[A-Za-z0-9]+$/;

export const isValidAddress = (str) => /^[A-Za-z0-9@.,'&\-_\(\)\{\}#\/\\|:\r\n ]+$/.test(str)
